import React, { createContext, useState } from 'react'
import { useContext } from 'react';

export const RedrirectContext=createContext({});

const RedirectProvider = ({children}) => {
   const [data, setData] = useState({
     redirectURLData: null,
     storeData: null,
     timeOutId: null,
     isLoading:true,
     isError:false
   });
  return (
    <RedrirectContext.Provider value={{ data, setData }}>
      {children}
    </RedrirectContext.Provider>
  );
}

export const useData=()=>useContext(RedrirectContext);
    
export default RedirectProvider;